import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  title: {
    id: 'category.not-found-page.title',
    defaultMessage: 'The requested page is unavailable or the URL is incorrect. Check the address and try again.',
    description: 'The title text for the not found page.',
  },
});

export default messages;
